<template>
  <tr>
    <td>
      {{tableRowNumber(currentPage, perPage, index)}}
    </td>
    <td class="d-flex align-items-center">
      <div class="mr-2">
        <img :src="artwork.imageThumbUrl" alt="">
      </div>
      <div class="d-flex flex-column">
        {{artwork.catalogNumber}}
        <span v-if="artist">
          {{artist.firstName}} {{artist.lastName}}
        </span>
        <span>{{artwork.name}}</span>
        {{artwork.date}}
      </div>
    </td>
    <td>
      {{I18n.t("price_with_currency", { price: formatNumber(artwork.startingPrice) })}}
    </td>
    <td>
      <span v-if="estimation">
        {{formatNumber(artwork.estimationMin)}} - {{formatNumber(artwork.estimationMax)}} {{I18n.t("artworks.currency")}}
      </span>
    </td>
    <td v-if="isReportedToBidding">
      <span v-if="isUnsold" class="unsold">
        {{ I18n.t("employees.results.auctions_catalogs.artworks.unsold") }}
      </span>
      <span v-else class="sold">
        {{I18n.t("price_with_currency", { price: formatNumber(auction.value) })}}
        <div v-if="isSoldConditionally" class="sold-conditionally">
          ({{ I18n.t("employees.results.auctions_catalogs.artworks.sold_conditionally") }})
        </div>
      </span>
    </td>
    <td v-else>
      {{ I18n.t("employees.results.auctions_catalogs.artworks.unreported") }}
    </td>
    <td>
      <AuctionWinner
        v-if="hasWinner"
        :auction="auction"
      />
    </td>
    <td>
      <button v-if="isReportedToBidding" v-on:click="$emit('show-modal', auction)" class="btn btn__default">
        {{ I18n.t("employees.results.auctions_catalogs.artworks.edit") }}
      </button>
    </td>
    <td>
      <div class="bid-dropdown position-static mb-2">
       <a
         id="showActions"
         class="dropdown-toggle"
         data-toggle="dropdown"
         aria-haspopup="true"
         aria-expanded="true"
         href=""
         data-offset="-30,-60"
       >
         <span class="icon icon-dots"></span>
       </a>
       <div class="dropdown-menu dropdown-menu-right profile__actions">
         <button
           class="dropdown-item"
           type="button"
           data-toggle="modal"
           @click="showModal()"
         >
           {{ I18n.t('employees.auctions_catalogs.destroy_artwork') }}
         </button>
          <a
            :href="editArtworkRoute"
            :title="I18n.t('employees.auctions_catalogs.edit_artwork')"
            data-method="get"
            rel="nofollow"
            class="dropdown-item"
          >
            {{ I18n.t('employees.auctions_catalogs.edit_artwork') }}
          </a>
       </div>
     </div>
    </td>
  </tr>
</template>

<script>
  import { mapActions } from 'vuex';
  import { tableRowNumber, formatNumber } from '@/shared/helpers';
  import { SOLD_STATE, SOLD_CONDITIONALLY_STATE, UNSOLD_STATE, DEFAULT_PER_PAGE } from './../../../consts';
  import AuctionWinner from './../auction_winner';

  /* global Routes */
  export default {
    name: 'FinishedAuctionsCatalogArtworksRow',
    props: {
      artwork: Object,
      index: Number,
      artist: Object,
      auction: Object,
      auctionsCatalog: Object,
      meta: Object,
    },
    components: {
      AuctionWinner,
    },
    created() {
      this.Routes = Routes;
    },
    computed: {
      perPage() {
        return this.meta.per_page || DEFAULT_PER_PAGE;
      },
      currentPage() {
        return this.$route.query.page || 1;
      },
      estimation() {
        return Number.isInteger(this.artwork.estimationMin) && this.artwork.estimationMax;
      },
      isReportedToBidding() {
        return this.auction;
      },
      isUnsold() {
        return this.auction.state === UNSOLD_STATE;
      },
      isSoldConditionally() {
        return this.auction.state === SOLD_CONDITIONALLY_STATE;
      },
      hasWinner() {
        return this.isReportedToBidding && !this.isUnsold;
      },
      editArtworkRoute() {
        return this.Routes.edit_employees_auctions_catalog_artwork_path(this.auctionsCatalog.id,
          this.artwork.id);
      },
    },
    methods: {
      ...mapActions('artworks', ['updateAuction']),
      newState(value) {
        return value ? SOLD_CONDITIONALLY_STATE : SOLD_STATE;
      },
      formatNumber(number) {
        return formatNumber(number);
      },
      tableRowNumber(currentPage, perPage, index) {
        return tableRowNumber(currentPage, perPage, index);
      },
      showModal() {
        this.$emit('show-deletion-modal', this.artwork, this.auctionsCatalog);
      },
    },
  };
</script>



// WEBPACK FOOTER //
// app/javascript/packs/employees/components/finished/artworks/row.vue?566ef521